import { Box } from '@material-ui/core';

import React from 'react';
import useStyles from './styles';
import Grid from '@material-ui/core/Grid';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import TextWithClicks from 'src/pages/reportUsage/common/textWithClicks/TextWithClicks.jsx';
//import ReportPrices from './ReportPrices';

import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileView } from 'src/utils/util';
import { useTranslation } from 'react-i18next';

const AccountOwnedList = ({ data }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Box
            className={classes.itemRow}
            my={1}
            bgcolor={'#FDFDFD'}
            borderRadius={6}
        >
            <Grid container spacing={2} direction="row">
                <Grid item xs={12} sm={6} md={3}>
                    <TextWithClicks
                        classes={classes}
                        leftTitle={data.cfn}
                        typeNonTissue={
                            !data.isBundleItem &&
                            (data.salesOrg === 'S002'
                                ? 'NT'
                                : data.salesOrg === 'S030'
                                ? 'T'
                                : undefined)
                        }
                        typeEA={!data.isBundleItem && data.uom}
                        justifyContentVal={isMobileView() && 'flex-end'}
                    />
                    <CustomLabel
                        fSize={'12px !important'}
                        paddingRight={'1rem!important'}
                        color={'#979797'}
                        label={data.description}
                    />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={9}
                    container
                    justifyContent={'space-between'}
                    spacing={1}
                    alignItems={'flex-start'}
                >
                    {data.lotSerial?.map((item) => {
                        return (
                            <>
                                <AccountItemContainer
                                    mbJustifyContent={
                                        item.used && item.other
                                            ? 'space-evenly'
                                            : 'flex-start'
                                    }
                                >
                                    {item.used && (
                                        <CustomLabel
                                            fSize={'13px !important'}
                                            styles={{
                                                fontFamily:
                                                    'AvenirNextWorld Demi',
                                                lineHeight: '30px',
                                                paddingBottom:
                                                    !isMobileView() && '5px',
                                            }}
                                            color={'#202124'}
                                            label={
                                                item.used === true
                                                    ? t('reportUsage.record.priceOverride.AccountOwnedList.index.used1')
                                                    : t('reportUsage.record.priceOverride.AccountOwnedList.index.used') + item.used
                                            }
                                        />
                                    )}

                                    {item.other && (
                                        <CustomLabel
                                            fSize={'13px !important'}
                                            styles={{
                                                fontFamily:
                                                    'AvenirNextWorld Demi',
                                                lineHeight: '30px',
                                            }}
                                            color={'#202124'}
                                            label={
                                                item.other === true
                                                    ? t('reportUsage.record.priceOverride.AccountOwnedList.index.other1')
                                                    : t('reportUsage.record.priceOverride.AccountOwnedList.index.used') + item.other
                                            }
                                        />
                                    )}
                                </AccountItemContainer>
                            </>
                        );
                    })}

                    <Grid item alignItems="flex-end">
                        <CustomLabel
                            fSize={'14px !important'}
                            styles={{
                                fontFamily: 'AvenirNextWorld Demi',
                                marginTop: '-1px',
                            }}
                            color={'#989898'}
                            label={t('reportUsage.record.priceOverride.AccountOwnedList.index.accountOwned')}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AccountOwnedList;

export const AccountItemContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    align-items: flex-end;
    width: 125px;
    ${media.mobileDevice`
        flex-direction: row;
        justify-content: ${({ mbJustifyContent }) => mbJustifyContent};
   `}
`;
